export default __webpack_public_path__ + "static/media/48.791c56ed.jpg";